import React, { ComponentProps, FC } from 'react'
import MuiTooltip from '@mui/material/Tooltip'
import styled from 'styled-components'
import { StylableMuiTooltip } from './StylableMuiTooltip'

type MuiTooltipProps = ComponentProps<typeof MuiTooltip>

export type Props = Omit<MuiTooltipProps, 'title'> & {
  title: MuiTooltipProps['title'] | null | undefined
  disableArrow?: boolean
  doNotWrapText?: boolean
}

export const Tooltip: FC<Props> = ({
  children,
  title,
  disableArrow = false,
  doNotWrapText = false,
  className,
  ...rest
}) => {
  if (!title) {
    return <>{children}</>
  }

  return (
    <StyledMuiTooltip
      {...rest}
      title={title}
      arrow={!disableArrow}
      $doNotWrapText={doNotWrapText}
      data-test="tooltip"
    >
      {children}
    </StyledMuiTooltip>
  )
}

const StyledMuiTooltip = styled(StylableMuiTooltip)<{ $doNotWrapText: boolean }>`
  ${props => props.$doNotWrapText && 'max-width: none !important;'};
`

export type TooltipProps = Props
export type TooltipPlacement = Props['placement']
